export const createManagedAttachmentsFromSaved = <TSavedAttachment, TManaged>(
  savedAttachments:
    | ReadonlyArray<TSavedAttachment | null | undefined>
    | null
    | undefined,
  mapSavedAttachment: (savedAttachment: TSavedAttachment) => TManaged
) => {
  return (
    savedAttachments
      ?.filter((savedAttachment): savedAttachment is NonNullable<
        typeof savedAttachment
      > => {
        return savedAttachment !== null && savedAttachment !== undefined;
      })
      .map((savedAttachment) => {
        return mapSavedAttachment(savedAttachment);
      }) || []
  );
};
